import { cn } from 'helpers/classnames';

export const inputClasses = `inline-flex items-center justify-center p-0.5 size-[20px] border-button-selected border rounded-full rounded-full appearance-none relative outline-offset-4 transition shrink-0`;

export const inputAfterClasses =
  '[&:not(:checked)]:after:opacity-0 [&:not(:checked)]:after:scale-75 after:transition after:bg-button-primary after:size-[12px] after:rounded-full';

export const disabledClasses =
  'disabled:cursor-not-allowed disabled:pointer-events-none disabled:border-button-disabled disabled:after:bg-button-disabled-minimal';

export const hoverClasses = 'hover:bg-gray-50';

export const hasParentFocusIndicatorClasses = 'outline-none';

export const wrapperClasses = 'flex items-center gap-2';

export const wrapperHadLabelClasses = cn(
  '[&:has(:focus-visible)]:outline-2 [&:has(:focus-visible)]:outline-button-focus outline-offset-2',
  'lumon:[&:has(input:focus-visible)]:outline lumon:outline-1 lumon:outline-gray-900 lumon:outline-offset-2'
);

export const labelClasses = 'body-s items-center flex w-full cursor-pointer leading-normal gap-x-[2px] text-gray-900 [input:focus+&]:!outline-none';

export const labelDisabledClasses = 'text-button-disabled-minimal';
